module.exports = __webpack_public_path__ + "4acd82321cc1afff32995443df39f74c.MP3";